import { render } from "./SensorStatWaterLeak.vue?vue&type=template&id=0884412c"
import script from "./SensorStatWaterLeak.vue?vue&type=script&lang=js"
export * from "./SensorStatWaterLeak.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__